
<div class="flex flex-column">

    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'text'">
            <ng-container *ngTemplateOutlet="text"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'numeric'">
            <ng-container *ngTemplateOutlet="numeric"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'checkbox'">
            <ng-container *ngTemplateOutlet="checkbox"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'textarea'">
            <ng-container *ngTemplateOutlet="textarea"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'time'">
            <ng-container *ngTemplateOutlet="time"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'datepicker'">
            <ng-container *ngTemplateOutlet="datepicker"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'select'">
            <ng-container *ngTemplateOutlet="select"></ng-container>
        </ng-container>
    </ng-container>
</div>

<ng-template #datepicker>
    <ng-container *ngTemplateOutlet="help"></ng-container>
    <form [formGroup]="fieldForm" style="padding-bottom: 16px;">
        <mat-form-field style="width:100%">
            <input matInput (dateChange)="onBlurDatePicker()" formControlName="field" [matDatepicker]="picker4" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4 disabled="false"></mat-datepicker>
            <button matSuffix mat-icon-button *ngIf="fieldForm.controls['field'] && fieldForm.controls['field'].value" (click)="clearSelection($event)" aria-label="Limpiar fecha">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </form>
</ng-template>

<ng-template #checkbox>
    <form [formGroup]="fieldForm" style="padding-bottom: 16px;">
        <div class="d-flex align-items-center" style="gap:4px;">            
            <mat-slide-toggle  formControlName="field"  (change)="onBlur()">
                
            </mat-slide-toggle>
            <ng-container *ngTemplateOutlet="help"></ng-container>
        </div>

        <mat-error *ngIf="fieldForm.controls['field'].hasError('pattern')">
            {{fieldForm.controls['field'].errors?.['pattern']}}
        </mat-error>
    </form>
</ng-template>

<ng-template #numeric>
    <form [formGroup]="fieldForm">
        <ng-container *ngTemplateOutlet="help"></ng-container>

        <mat-form-field style="width:100%">

            <input #itext matInput type="number" formControlName="field" (blur)="onBlur()" (keydown)="onKeyDown($event)"
                style="width: 100%;">
            <mat-error *ngIf="fieldForm.controls['field'].hasError('pattern')">
                {{fieldForm.controls['field'].errors?.['pattern']}}
            </mat-error>
        </mat-form-field>
    </form>
</ng-template>

<ng-template #time>
    <form [formGroup]="fieldForm">
        <ng-container *ngTemplateOutlet="help"></ng-container>

        <mat-form-field style="width: 100%;">
            <mat-icon matPrefix style="transform: translateY(3px);">schedule</mat-icon>
            <app-time formControlName="field" (onBlur)="onBlur($event)"></app-time>

        </mat-form-field>

    </form>
</ng-template>

<ng-template #text>
    <form [formGroup]="fieldForm">
        <ng-container *ngTemplateOutlet="help"></ng-container>

        <mat-form-field style="width:100%">

            <input #itext matInput formControlName="field" (blur)="onBlur()" (keydown)="onKeyDown($event)"
                style="width: 100%;">
            <mat-error *ngIf="fieldForm.controls['field'].hasError('pattern')">
                {{fieldForm.controls['field'].errors?.['pattern']}}
            </mat-error>
        </mat-form-field>
    </form>
</ng-template>

<ng-template #select>
    <form [formGroup]="fieldForm">
        <ng-container *ngTemplateOutlet="help"></ng-container>
        <mat-form-field style="width: 100%;">
            <mat-select formControlName="field" (selectionChange)="onBlur()" >
                @for (option of options; track $index) {
                    <mat-option [value]="option.value">{{option.name}}</mat-option> 
                }
            </mat-select>
            <button mat-icon-button *ngIf="deleteSelector && fieldForm.get('field')?.value" matSuffix aria-label="Clear" (click)="clearSelection($event)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </form>
</ng-template>

<ng-template #help>
    <app-help-label  [toolTipMsg]="toolTipMsg">
        {{label}}
    </app-help-label>
</ng-template>

<ng-template #textarea>
    <ng-container *ngTemplateOutlet="help"></ng-container>

    <div tabindex="0">

        <form [formGroup]="fieldForm" class="d-flex rich-text" style="width: 100%; margin-bottom: 16px;">
            
            <quill-editor customToolbarPosition="bottom" formControlName="field" format="html" (blur)="onBlur()">

            </quill-editor>

        </form>
    </div>
</ng-template>